import React from 'react';
import PropTypes from 'prop-types';

const FormFooter = ({
    showSave,
    onSave,
    showPreview,
    questSlug,
    quest,
}) => {
    const handlePreviewQuest = () => {
        const win = window.open(`/quests/${questSlug}`, '_blank');
        win.focus();
    };


    const handlePreviewRequirements = () => {
        const host = window.location.hostname;
        const isLocal = host === 'localhost';
        const finalHost = isLocal ? `${host}:3000` : host;
        const protocol = isLocal ? 'http://' : 'https://';
        const { id } = quest;
        window.open(`${protocol}${finalHost}/my-quests/preview/${id}`, '_blank');
    };

    if (!showSave) return null;

    return (
        <div className="form__footer">
            <input
                type="submit"
                className="CCQuests__save--btn"
                value="Save"
                onClick={onSave}
            />

            {showPreview && (
                <>
                    <input
                        type="button"
                        className="CCQuests__preview-slug--btn"
                        value="Preview Quest Page"
                        onClick={handlePreviewQuest}
                    />
                    <input
                        type="button"
                        className="CCQuests__preview-req--btn"
                        value="Preview Requirements Page"
                        data-tip="Visual reference only - do not interact with page"
                        onClick={handlePreviewRequirements}
                    />
                </>
            )}
        </div>
    );
};

FormFooter.propTypes = {
    showSave: PropTypes.bool.isRequired,
    onSave: PropTypes.func,
    showPreview: PropTypes.bool,
    questSlug: PropTypes.string,
    quest: PropTypes.object,
    onPreviewRequirements: PropTypes.func
};

FormFooter.defaultProps = {
    showSave: true,
    showPreview: false
};

export default React.memo(FormFooter);